import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=2c39330e&"
import script from "./sticky.vue?vue&type=script&lang=js&"
export * from "./sticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports